import { Ticket } from "../../../../../models/Ticket";
import { TICKETS_BOUGHT_IN_DISPLAY } from "../../../../../utils/Constants";
import SeeMore from "../../../../miscellaneous/SeeMore";
import TicketEntry from "../../../../miscellaneous/TicketEntry";

export interface TicketsBoughtProps {
  drawDate: Date | undefined;
  ticketsBought: Ticket[];
  onSeeMore: () => void;
}

export default function TicketsBought(props: TicketsBoughtProps) {
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
  };
  const formattedDate: string | undefined = props.drawDate?.toLocaleDateString(
    undefined,
    options,
  );
  return (
    <div
      className="flex flex-col lg:items-start items-center"
      data-aos="fade-up"
    >
      <div className="~mb-0.5/2 font-barlowc font-bold ~text-base/lg bg-gradient-to-b from-mango to-crail bg-clip-text text-transparent">
        YOUR TICKETS FOR {formattedDate?.toUpperCase() ?? "..."} (
        {props.ticketsBought.length})
      </div>
      {props.ticketsBought.length == 0 && (
        <div className="text-silver font-poppins ~text-sm/base">
          Zip. Zilch. Nada. Let's get those numbers rolling!
        </div>
      )}
      {props.ticketsBought
        .slice(0, TICKETS_BOUGHT_IN_DISPLAY)
        .map((entry, index) => (
          <div className="~p-1/1.5 my-1 bg-bastille rounded-md" key={index}>
            <TicketEntry ticket={entry}></TicketEntry>
          </div>
        ))}
      {props.ticketsBought.length > TICKETS_BOUGHT_IN_DISPLAY && (
        <div className="self-end">
          <SeeMore onSeeMore={props.onSeeMore}></SeeMore>
        </div>
      )}
    </div>
  );
}
